import React from "react";

const DogGrooming = () => {
  return (
    <section className="py-8 px-8 md:px-16 font-[Quicksand] text-gray-800 leading-relaxed">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start gap-10">
        {/* Kiri: Deskripsi Layanan */}
        <div className="md:w-1/2 space-y-5">
          <h2 className="text-2xl font-bold text-gray-900">
            Services – Dog Grooming
          </h2>

          <p className="text-lg">
            Professional grooming, tailored to your dog.
          </p>

          <p className="text-lg">
            From first-time puppy trims to full breed standards, we have a
            package just for your pup.
          </p>

          <p className="text-lg font-semibold text-gray-900">
            Our grooming packages
          </p>

          <ul className="list-disc list-inside text-base text-gray-700 space-y-2">
            <li>
              <strong>Comfort Clip / Shave:</strong> A smart, low-maintenance
              full-body trim. Perfect for warm months or active dogs.
            </li>
            <li>
              <strong>Fluff Cut / Breed Standard Cut:</strong> Precision styling
              for teddy-bear trims, show-look coats, or your dog’s signature
              look.
            </li>
            <li>
              <strong>Tidy-Up Groom:</strong> Quick refresh between full grooms
              — bath, dry, and light trim.
            </li>
            <li>
              <strong>First Puppy Tidy:</strong> A gentle introduction to
              grooming for puppies; comfort, confidence, and a happy pup.
            </li>
            <li>
              <strong>Bath & Blow Dry:</strong> Deep clean, blow-dry, ear-clean,
              nail-trim — for short and long-haired breeds alike.
            </li>
          </ul>

          <div>
            <p className="text-lg font-semibold text-gray-900 pt-4">
              Add-On Services
            </p>
            <p className="text-lg">
              Enhance your dog’s experience with extras:
            </p>
            <ul className="list-disc list-inside text-base text-gray-700 space-y-2">
              <li>Ear Clean</li>
              <li>Medicated Shampoo</li>
              <li>Flea Treatment</li>
              <li>De-Shedding</li>
              <li>Teeth Brushing</li>
              <li>Nail Trim</li>
              <li>Face Tidy</li>
            </ul>
          </div>

          <p className="text-lg">
            Pricing is based on dog size:
            <br />
            <span className="italic text-base text-gray-700">
              Small &lt; 5kg | Medium 5–10kg | Large 10–20kg | Extra Large &gt;
              20kg
            </span>
          </p>
        </div>

        {/* Kanan: Tabel Harga */}
        <div className="md:w-1/2 overflow-x-auto">
          <table className="min-w-full border-collapse text-center rounded-2xl shadow-md overflow-hidden text-sm md:text-base font-[Quicksand]">
            <thead>
              <tr className="bg-[#F5A19D] text-white">
                <th className="p-3 border border-gray-300">Service</th>
                <th className="p-3 border border-gray-300">
                  Small
                  <br />
                  (&lt;5kg)
                </th>
                <th className="p-3 border border-gray-300">
                  Medium
                  <br />
                  (5–10kg)
                </th>
                <th className="p-3 border border-gray-300">
                  Large
                  <br />
                  (10–20kg)
                </th>
                <th className="p-3 border border-gray-300">
                  Extra Large
                  <br />
                  (&gt;20kg)
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ["Comfort Clip", "$105", "$115", "$130", "$155"],
                ["Style Clip", "$115", "$125", "$160", "$175"],
                ["Maintenance Tidy Up", "$85", "$95", "$105", "$115"],
                ["Bath and Blow Dry – Short Coat", "$50", "$60", "$70", "$80"],
                ["Bath and Blow Dry – Long Coat", "$60", "$70", "$80", "$95"],
                ["Puppy First Tidy", "$85", "$95", "", ""],
              ].map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={rowIndex % 2 === 0 ? "bg-gray-100" : "bg-white"}
                >
                  {row.map((cell, cellIndex) => (
                    <td
                      key={cellIndex}
                      className={`p-3 border border-gray-300 ${
                        cellIndex === 0
                          ? "bg-[#F5A19D] text-white font-medium"
                          : ""
                      }`}
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default DogGrooming;
